import React, { Component } from 'react';
import { Auth } from '../../../../services/api';
import { Form, Alert } from 'antd';
import RegisterForm from './RegisterForm';

const WrappedForm = Form.create()(RegisterForm)

export default class Register extends Component {
    constructor(props) {
        super(props);

        this.authApi = new Auth();    

        this.state = {
            loading: false,
            success: false
        };
    }

    register = (data) => {
        this.setState({ loading: true });
        this.authApi.register(data)
            .then(() => {
                this.setState({ success: true, loading: false });
            })
            .catch(_ => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { success, loading  } = this.state;

        return (
            <div>
                {success && (
                    <Alert
                        type="success"
                        showIcon
                        message="Ditt konto är nu registrerat, vi har skickat ett verifieringsmejl till den e-post du angav."
                        style={{ marginBottom: '20px' }}
                    />
                )}
                <WrappedForm loading={loading} onSubmit={this.register} />
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/register/Register.js